import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import PublicLayout, { ScrollToTop } from '@/components/layout/PublicLayout';
import Home from '@/pages/Home';
import Companies from '@/pages/Companies';
import CompanyDetail from '@/pages/CompanyDetail';
import Opportunities from '@/pages/Opportunities';
import OpportunityDetail from '@/pages/OpportunityDetail';
import Categories from '@/pages/Categories';
import About from '@/pages/About';
import Community from '@/pages/Community';
import InfoPage from '@/pages/InfoPage';
import NotFound from '@/pages/NotFound';
import { Login, Signup, Recover } from '@/pages/auth/AuthPages';
import RegisterCompany from '@/pages/auth/RegisterCompany';
import DashboardLayout from '@/pages/dashboard/DashboardLayout';
import { Overview, MyOpportunities, Publish, EditPublications, EditOpportunity } from '@/pages/dashboard/DashboardPages';
import { ProfilePage, ServicesPage, SettingsPage } from '@/pages/dashboard/ProfilePages';
import { InboxPage } from '@/pages/dashboard/InboxPage';
import { AdvertisePage } from '@/pages/dashboard/AdvertisePage';
import AdminLayout from '@/pages/admin/AdminLayout';
import { AdminOverview, AdminCompanies, AdminOpportunities, AdminReports, AdminUsers, AdminCategories } from '@/pages/admin/AdminPages';
import { AdminSponsored } from '@/pages/admin/AdminSponsored';
import { TooltipProvider } from '@/components/ui/tooltip';

const INFO = ['termos', 'privacidade', 'diretrizes', 'contato', 'publicidade', 'como-funciona'];

function App() {
  return (
    <TooltipProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="empresas" element={<Companies />} />
            <Route path="empresas/:id" element={<CompanyDetail />} />
            <Route path="oportunidades" element={<Opportunities />} />
            <Route path="oportunidades/:id" element={<OpportunityDetail />} />
            <Route path="categorias" element={<Categories />} />
            <Route path="sobre" element={<About />} />
            <Route path="comunidade" element={<Community />} />
            <Route path="entrar" element={<Login />} />
            <Route path="criar-conta" element={<Signup />} />
            <Route path="recuperar-senha" element={<Recover />} />
            <Route path="cadastrar-empresa" element={<RegisterCompany />} />
            {INFO.map((s) => <Route key={s} path={s} element={<InfoPage slug={s} />} />)}
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="painel" element={<DashboardLayout />}>
            <Route index element={<Overview />} />
            <Route path="perfil" element={<ProfilePage />} />
            <Route path="servicos" element={<ServicesPage />} />
            <Route path="oportunidades" element={<MyOpportunities />} />
            <Route path="publicar" element={<Publish />} />
            <Route path="publicacoes" element={<EditPublications />} />
            <Route path="publicacoes/:id/editar" element={<EditOpportunity />} />
            <Route path="mensagens" element={<InboxPage />} />
            <Route path="anunciar" element={<AdvertisePage />} />
            <Route path="configuracoes" element={<SettingsPage />} />
          </Route>
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="empresas" element={<AdminCompanies />} />
            <Route path="oportunidades" element={<AdminOpportunities />} />
            <Route path="denuncias" element={<AdminReports />} />
            <Route path="contas" element={<AdminUsers />} />
            <Route path="categorias" element={<AdminCategories />} />
            <Route path="patrocinados" element={<AdminSponsored />} />
          </Route>
        </Routes>
        <Toaster theme="dark" position="bottom-right" richColors closeButton toastOptions={{ style: { background: '#0b0f16', border: '1px solid rgba(255,255,255,0.1)' } }} />
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;